export default __webpack_public_path__ + "static/media/Luchtdichtheid-popup-image.50855782.png";